module.exports = __webpack_public_path__ + "img/icon-password1.a2a4be81.svg";